(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import { Routes, Route } from "react-router";
import { useSelector } from "../../../store";
import { selectors as appSelectors } from "../../App";
import SearchTableContainer from "./SearchTableContainer";
import SearchDetailsContainer from "./SearchDetailsContainer";
import Search from "../components/Search";
import useInit from "./hooks/useInit";

const SearchContainer = () => {
  const {
    isReady
  } = useInit();
  const config = useSelector(appSelectors.configSelector);
  return /*#__PURE__*/React.createElement(Search, {
    isReady: isReady,
    logoSrc: config.logoSrc,
    colors: config.colors,
    basicUrl: config.basicUrl
  }, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    index: true,
    element: /*#__PURE__*/React.createElement(SearchTableContainer, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: ":hsCode",
    element: /*#__PURE__*/React.createElement(SearchDetailsContainer, null)
  })));
};

__signature__(SearchContainer, "useInit{{ isReady }}\nuseSelector{config}", () => [useInit, useSelector]);

const _default = /*#__PURE__*/React.memo(SearchContainer);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(SearchContainer, "SearchContainer", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchContainer.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/SearchContainer.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();